/* Reserve the space occupied by visible fixed actions for Shopify Inbox.
 * Measure rather than assume a height: labels, safe areas and builder steps vary.
 */
(() => {
  const root = document.documentElement;
  const selector = '.kb-cart__mobile-checkout, .kb-full-builder__mobile-steps, [data-kb-full-add]';
  const observed = new Set();
  let queued = false;
  let previousInset;

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }

  const sizes = new ResizeObserver(schedule);

  function update() {
    queued = false;
    const bars = new Set(document.querySelectorAll(selector));
    for (const bar of observed) {
      if (!bars.has(bar)) {
        sizes.unobserve(bar);
        observed.delete(bar);
      }
    }
    const viewportHeight = window.innerHeight;
    let inset = 0;
    for (const bar of bars) {
      if (!observed.has(bar)) {
        sizes.observe(bar);
        observed.add(bar);
      }
      const style = getComputedStyle(bar);
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') continue;
      const rect = bar.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= viewportHeight) continue;
      inset = Math.max(inset, viewportHeight - Math.max(0, rect.top));
    }
    inset = Math.ceil(inset);
    if (inset !== previousInset) {
      root.style.setProperty('--kb-sticky-bottom-inset', `${inset}px`);
      previousInset = inset;
    }
  }

  // Covers AJAX carts and the builder's navigation portal / step changes.
  new MutationObserver(schedule).observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['class', 'style', 'hidden', 'data-kb-mobile-step']
  });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  schedule();
})();
